import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=19fd2d30&scoped=true"
import script from "./MessageIcon.vue?vue&type=script&lang=js"
export * from "./MessageIcon.vue?vue&type=script&lang=js"
import style0 from "./MessageIcon.vue?vue&type=style&index=0&id=19fd2d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd2d30",
  null
  
)

export default component.exports